import Icon from '../../components/Icon.vue'

Icon.register({"regular/edit":{"width":576,"height":512,"paths":[{"d":"M402.3 344.9L434.3 312.9C439.3 307.9 448 311.4 448 318.6V464C448 490.5 426.5 512 400 512H48C21.5 512 0 490.5 0 464V112C0 85.5 21.5 64 48 64H321.5C328.6 64 332.2 72.6 327.2 77.7L295.2 109.7C293.7 111.2 291.7 112 289.5 112H48V464H400V350.5C400 348.4 400.8 346.4 402.3 344.9zM558.9 143.1L296.3 405.7 205.9 415.7C179.7 418.6 157.4 396.5 160.3 370.1L170.3 279.7 432.9 17.1C455.8-5.8 492.8-5.8 515.6 17.1L558.8 60.3C581.7 83.2 581.7 120.3 558.9 143.1zM460.1 174L402 115.9 216.2 301.8 208.9 367.1 274.2 359.8 460.1 174zM524.9 94.3L481.7 51.1C477.6 47 470.9 47 466.9 51.1L436 82 494.1 140.1 525 109.2C529 105 529 98.4 524.9 94.3z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/edit.js
// module id = qz86
// module chunks = 0